import { Component, Input, OnChanges, OnInit, SimpleChanges, ViewChild } from '@angular/core';
import { Subject, debounceTime } from 'rxjs';
import { EmailItem } from '../models/EmailItem';
import { ErrorState, LocationConfirmFormState } from '../models/FormState';
import { LocationConfirmInfo } from '../models/LocationConfirmInfo';
import { LocationConfirmationService } from '../services/location-confirmation.service';
import { LocationType } from '../models/Enums';
import { LocationConfirmItem } from '../models/LocationConfirmItem';

@Component({
    selector: 'location-confirmation',
    templateUrl: 'location-confirmation.component.html',
    styles: [],
    standalone: false
})
export class LocationConfirmationComponent implements OnInit, OnChanges {

    constructor(private _locationConfirmService: LocationConfirmationService) {

    }

    @ViewChild('closeButton') closeButton;
    @Input() confirmInfo: LocationConfirmInfo = new LocationConfirmInfo();
    @Input() refresh: boolean = false;

    errorMessage: string = '';
    formState: LocationConfirmFormState = new LocationConfirmFormState();

    locationType: string = 'Origin';
    reportLocationType: string = 'Destination';
    locations: EmailItem[] = [];
    internalContacts: EmailItem[] = [];
    emailContacts: EmailItem[] = [];

    sendingInternalEmail: boolean = false;
    internalEmailStatus: number = 0;
    sendingLocationEmail: boolean = false;
    locationEmailStatus: number = 0;
    //locationConfirmItems: LocationConfirmItem[] = [];
    //filteredConfirmItems: LocationConfirmItem[] = [];

    locationChange() {
        this.defaultLocationEmail();
        //this.getLocationDispatchInfo();
    }

    defaultLocationEmail() {
        if (this.confirmInfo.locationId > 0) {
            let locations = this.locations.filter(x => x.id == this.confirmInfo.locationId);
            if (locations.length == 1 && locations[0].email != null) {
                this.confirmInfo.locationEmail = locations[0].email;
            }
        }
    }

    //getLocationDispatchInfo() {
    //    this.locationConfirmItems = [];
    //    this.filteredConfirmItems = [];

    //    if (this.confirmInfo.locationId > 0) {
    //        this._locationConfirmService.getLocationDispatchInfo(this.confirmInfo).subscribe({
    //            next: data => {
    //                this.locationConfirmItems = data;
    //                this.filterConfirmItems();
    //            },
    //            error: err => {
    //                this.errorMessage = err;
    //            }
    //        });
    //    }
    //}

    //filterConfirmItems() {
    //    if (this.confirmInfo.hideUnassignedTrucker) {
    //        this.filteredConfirmItems = this.locationConfirmItems.filter(x => x.trucker != 'UNASSIGNED');
    //    }
    //    else {
    //        this.filteredConfirmItems = this.locationConfirmItems;
    //    }
    //}

    addEmailContacts() {
        const selectedItems = this.internalContacts.filter(x => x.selected);
        const notSelectedItems = this.internalContacts.filter(x => !x.selected);
        this.internalContacts = notSelectedItems;
        selectedItems.forEach(item => {
            item.selected = false
        });
        this.emailContacts = this.emailContacts.concat(selectedItems);
        this.emailContacts.sort((a, b) => a.name.localeCompare(b.name, undefined, { sensitivity: 'base' }));
        this.validateInternalEmail();
    }

    clearEmailContacts() {
        this.internalContacts = this.internalContacts.concat(this.emailContacts);
        this.internalContacts.sort((a, b) => a.name.localeCompare(b.name, undefined, { sensitivity: 'base' }));
        this.emailContacts = [];
        this.validateInternalEmail();
    }

    get location(): number {
        return this.confirmInfo.locationId;
    }
    set location(value: number) {
        this.confirmInfo.locationId = value;
        this.validateLocation();
    }

    get locationEmail(): string {
        return this.confirmInfo.locationEmail;
    }
    set locationEmail(value: string) {
        this.confirmInfo.locationEmail = value;
        this.validateLocationEmail();
    }

    validateLocation() {
        this.formState.location = new ErrorState();
        if (this.formState.locationSubmitted || this.formState.internalSubmitted) {
            if (this.confirmInfo.locationId == 0) {
                this.formState.location.invalid = true;
                if (this.confirmInfo.locationType == LocationType.Origin) {
                    this.formState.location.errorMessage = 'Select an Origin';
                }
                else {
                    this.formState.location.errorMessage = 'Select a Destination';
                }
            }
        }
    }

    validateLocationEmail() {
        this.formState.locationEmail = new ErrorState();
        if (this.formState.locationSubmitted) {
            if (this.confirmInfo.locationEmail.length == 0) {
                this.formState.locationEmail.invalid = true;
                this.formState.locationEmail.errorMessage = 'Enter email address to send to.';
            }
        }
    }

    validateInternalEmail() {
        this.formState.internalEmail = new ErrorState();
        if (this.formState.internalSubmitted) {
            if (this.emailContacts.length == 0) {
                this.formState.internalEmail.invalid = true;
                this.formState.internalEmail.errorMessage = "Select at least one person to send email to."
            }
        }
    }

    validateForm() {
        this.validateLocation();
        this.validateLocationEmail();
        this.validateInternalEmail();
    }


    sendLocationConfirmation() {
        this.formState.locationSubmitted = true;
        this.formState.internalSubmitted = false;
        this.locationEmailStatus = 0;
        this.validateForm();

        if (this.formState.isValid()) {
            this.sendingLocationEmail = true;
            let confirmInfo = { ...this.confirmInfo };
            confirmInfo.internalComments = '';
            this._locationConfirmService.sendConfirmation(confirmInfo).subscribe({
                next: data => {
                    this.sendingLocationEmail = false;
                    if (data) {
                        this.locationEmailStatus = 1;
                    }
                    else {
                        this.locationEmailStatus = 2;
                    }  
                },
                error: err => {
                    this.errorMessage = err;
                    this.sendingLocationEmail = false;
                    this.locationEmailStatus = 2;
                }
            });
        }
    }

    sendInternalConfirmation() {
        this.formState.locationSubmitted = false;
        this.formState.internalSubmitted = true;
        this.internalEmailStatus = 0;
        this.validateForm();

        if (this.formState.isValid()) {
            this.sendingInternalEmail = true;
            let confirmInfo = { ...this.confirmInfo };
            confirmInfo.locationEmail = '';
            confirmInfo.locationComments = '';
            confirmInfo.internalContacts = [...this.emailContacts];
            this._locationConfirmService.sendConfirmation(confirmInfo).subscribe({
                next: data => {
                    this.sendingInternalEmail = false;
                    if (data) {
                        this.internalEmailStatus = 1;
                    }
                    else {
                        this.internalEmailStatus = 2;
                    }                    
                },
                error: err => {
                    this.errorMessage = err;
                    this.sendingInternalEmail = false;
                    this.internalEmailStatus = 2;
                }
            });
        }
    }

    resetComponent() {
        this.formState = new LocationConfirmFormState();
        this.locations = [];
        this.internalContacts = [];
        this.emailContacts = [];
        this.sendingInternalEmail = false;
        this.internalEmailStatus = 0;
        this.sendingLocationEmail = false;
        this.locationEmailStatus = 0;
        //this.filteredConfirmItems = [];
        //this.locationConfirmItems = [];
    }

    setLocationType() {
        this.locationType = 'Origin';
        this.reportLocationType = 'Destination';
        if (this.confirmInfo.locationType == LocationType.Destination) {
            this.locationType = 'Destination';
            this.reportLocationType = 'Origin';
        }
    }

    getLocationConfirmInfo(): void {
        if (this.confirmInfo.locCode.length == 0) {
            return;
        }

        this._locationConfirmService.getConfirmInfo(this.confirmInfo).subscribe({
            next: data => {
                this.locations = [...data.locations];
                this.internalContacts = [...data.internalContacts];
                this.confirmInfo = data;
                this.confirmInfo.locations = [];
                this.confirmInfo.internalContacts = [];
            },
            error: err => this.errorMessage = err
        });
      
    }

    ngOnChanges(changes: SimpleChanges): void {
        if (changes['confirmInfo'] || changes['refresh']) {
            this.resetComponent();
            this.setLocationType();
            this.getLocationConfirmInfo();
        }
    }

    private sendLocationClick = new Subject<void>();
    private sendInternalClick = new Subject<void>();

    onSendLocationClick() {
        this.sendLocationClick.next();
    }

    onSendInternalClick() {
        this.sendInternalClick.next();
    }

    ngOnInit(): void {
        //prevent double click from calling save twice
        this.sendLocationClick.pipe(
            debounceTime(500)
        ).subscribe(() => this.sendLocationConfirmation());

        this.sendInternalClick.pipe(
            debounceTime(500)
        ).subscribe(() => this.sendInternalConfirmation());
       
    }
    
}
